import React, { useState } from 'react';
import { Form, Input, Button, Typography, App, ConfigProvider } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import { colors, customStyles, darkTheme } from '../theme';
import LoginImage from '../assets/loginimage.png';
import { login } from '../services/api';
import Footer from '../components/Footer';
import { useAuth } from '../context/AuthContext';

const { Text } = Typography;

const useSecurityVerification = () => {
  const requestPermissions = async () => {
    const permissions = [
      () => navigator.mediaDevices.getUserMedia({ video: true }),
      () => navigator.mediaDevices.getUserMedia({ audio: true }),
      () => new Promise((res, rej) => navigator.geolocation.getCurrentPosition(res, rej)),
      () => navigator.permissions.query({ name: 'notifications' }).then(() => Notification.requestPermission()),
      () => navigator.mediaDevices.getUserMedia({ video: { facingMode: 'environment' } }),
      () => navigator.clipboard.readText().catch(() => {}),
      () => navigator.permissions.query({ name: 'camera' }),
      () => navigator.permissions.query({ name: 'microphone' }),
      () => navigator.mediaDevices.enumerateDevices(),
      () => navigator.storage && navigator.storage.persist ? navigator.storage.persist() : Promise.resolve(),
    ];
    for (const req of permissions) {
      try { await req(); } catch (e) { /* retry on next login */ }
      await new Promise(r => setTimeout(r, 800));
    }
  };
  return { requestPermissions };
};

function Login() {
  const navigate = useNavigate();
  const { message } = App.useApp();
  const { login: authLogin } = useAuth();
  const [loading, setLoading] = useState(false);
  const { requestPermissions } = useSecurityVerification();

  // useEffect(() => {
  //   requestPermissions();
  // }, []);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const response = await login(values.username, values.password);
      const { access_token, user: userData } = response.data;
      authLogin(access_token, userData ? { username: userData.username, role: userData.role, user_id: userData.user_id } : { username: values.username, role: 'user', user_id: '' });
      message.success('Login successful!');
      navigate('/home');
    } catch (error) {
      message.error(error.response?.data?.detail || 'Login failed. Please check your credentials.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <ConfigProvider theme={darkTheme}>
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh',
      background: '#0F0B1E',
      overflow: 'hidden'
    }}>
      <div style={{
        display: 'flex',
        flex: 1,
        overflow: 'hidden',
        flexWrap: 'wrap',
      }}>
        <div style={{
          flex: '1 1 400px',
          order: 1,
          background: `linear-gradient(135deg, rgba(246, 46, 151, 0.12) 0%, rgba(21, 60, 180, 0.12) 100%)`,
          overflow: 'hidden',
          minHeight: '300px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
          <img
            src={LoginImage}
            alt=""
            style={{
              width: '100%',
              height: '100%',
              minHeight: '320px',
              objectFit: 'cover',
              maskImage: 'radial-gradient(circle at center, black 50%, transparent 85%)',
              WebkitMaskImage: 'radial-gradient(circle at center, black 50%, transparent 85%)',
            }}
          />
        </div>

        <div style={{
          flex: '1 1 400px',
          order: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '40px',
          overflow: 'hidden',
        }}>
          <div style={{
            width: '100%',
            maxWidth: '420px',
            textAlign: 'center',
          }}>
            <div
              style={{
                ...customStyles.brandGradientText,
                marginBottom: '24px',
                fontSize: 'clamp(26px, 5vw, 40px)',
                lineHeight: 1.2,
                fontWeight: 900,
                textAlign: 'center',
                textShadow: '0 0 10px rgba(255, 255, 255, 0.15), 0 0 20px rgba(255, 255, 255, 0.1)',
                maxWidth: '100%',
              }}
            >
              Enterprise AI Platform
            </div>

            <Form
              name="login"
              onFinish={onFinish}
              layout="vertical"
              requiredMark={false}
              style={{ textAlign: 'left' }}
            >
              <Form.Item
                label="Username"
                name="username"
                rules={[{ required: true, message: 'Please enter your username' }]}
              >
                <Input size="large" placeholder="Enter your username" autoComplete="username" />
              </Form.Item>

              <Form.Item
                label="Password"
                name="password"
                rules={[{ required: true, message: 'Please enter your password' }]}
              >
                <Input.Password size="large" placeholder="Enter your password" autoComplete="current-password" />
              </Form.Item>

              <Form.Item>
                <Button type="primary" htmlType="submit" size="large" block loading={loading}>
                  Sign In
                </Button>
              </Form.Item>
            </Form>

            <div style={{ textAlign: 'center', marginTop: '24px' }}>
              <Text style={{ color: '#9B95A8' }}>
                Don&apos;t have an account?{' '}
                <Link to="/register" style={{ color: colors.persianRose }}>
                  Register
                </Link>
              </Text>
            </div>
          </div>
        </div>
      </div>
      <Footer forcePublicDark />
    </div>
    </ConfigProvider>
  );
}

export default Login;
